import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import style from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import {} from '@ifeng-fe/ui_base';

import Footer from '../footer';

/**
 * for this page
 */
// import Content from './content/';

class NextPage extends React.PureComponent {
    static propTypes = {
        windowHeight: PropTypes.number,
    };

    state = {
        windowHeight: this.props.windowHeight,
        increment: ['风铃计划', '金风计划', '资金扶持', '榜单激励'],
        service: ['MCN入驻扶持', '版权保护', '专业编辑团队'],
    };

    static getDerivedStateFromProps = (props, state) => {
        let resWHeight = {};

        if (props.windowHeight !== state.windowHeight) {
            resWHeight = { windowHeight: props.windowHeight };
        }

        return { ...resWHeight };
    };

    render() {
        /**
         * 组件分发数据
         */
        const { windowHeight, increment, service } = this.state;

        return (
            <div className={style.nextPage} style={{ marginTop: `${windowHeight}px` }}>
                <div className={style.section1}>
                    <div className={style.container}>
                        <div className={style.title}>内容增值矩阵</div>
                        <div className={style.dec}>多重激励，投入10亿打造凤凰优质内容</div>
                        <div className={'clearfix ov'}>
                            {increment.map((item, index) => {
                                return (
                                    <div
                                        className={style.zengzhi}
                                        key={item}
                                        style={{ marginRight: index === increment.length - 1 ? 0 : 24 }}>
                                        <div className={style[`zengzhi${index + 1}`]} />
                                        <p className={style.txt}>{item}</p>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
                <div className={style.section2}>
                    <div className={style.container}>
                        <div className={style.title}>内容传播矩阵</div>
                        <div className={style.dec}>一键发布多平台分发，精准抵达目标人群</div>
                        <div className={style.preview} />
                    </div>
                </div>
                <div className={style.section3}>
                    <div className={style.container}>
                        <div className={style.title}>内容服务矩阵</div>
                        <div className={style.dec}>贴心服务，为内容创作者安心写作保驾护航</div>
                        <div className={`${style.serviceWraaper} clearfix`}>
                            {service.map((item, index) => {
                                return (
                                    <div
                                        className={style.fuwu}
                                        key={item}
                                        style={{ marginRight: index === service.length - 1 ? 0 : 89 }}>
                                        <div className={style[`fuwu${index + 1}`]} />
                                        <p className={style.txt}>{item}</p>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
                <div className={style.section4}>
                    <div className={style.container}>
                        <div className={style.txt}>
                            <div className={style.title}>内容海量矩阵</div>
                            <div className={style.dec}>海量高品质内容，多领域全覆盖</div>
                        </div>
                        <div className={style.contentPic} />
                    </div>
                </div>
                <div className={style.cloud1} />
                <div className={style.cloud2} />
                <div style={{ width: '100%', background: '#F7F7F7' }}>
                    <Footer />
                </div>
            </div>
        );
    }
}

export default errorBoundary(NextPage);
